﻿import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'bldgtrackingtype'
})
export class BldgtrackingtypePipe implements PipeTransform {
    
    transform(ProjectBuildingTracking: Array<any>, trackingType?: number): any {
      
        if (trackingType == null || ProjectBuildingTracking == null) { 
            //return ProjectBuildingTracking;
            return [null];
        }
        /*
        return ProjectBuildingTracking.filter(function (entry) {
            if (entry.BuildingTrackingType != null) {
                
                if (entry.BuildingTrackingType.SeqNo == trackingType) {
                     return entry.BuildingTrackingType.SeqNo == trackingType;
                    //return entry;
                }                    
            }
        })
        */

        return ProjectBuildingTracking.filter(function (entry) {
            if (entry.BuildingTrackingType != null) {

                if (entry.BuildingTrackingType.SeqNo == trackingType) {
                    return entry.BuildingTrackingType.SeqNo == trackingType;
                    //return entry;
                }
            }
        })

    }

}